module.exports = __webpack_public_path__ + "static/media/010_iOS - 12 - MESSAGE CENTER.9e6ac320.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/010_iOS - 12 - MESSAGE CENTER.png
// module id = 507
// module chunks = 0